<template>
  <div class="container my-4">
    <div class="card card-data-builder">
      <ul id="horizontal-nav" class="nav nav-horizontal">
        <li class="nav-item" :class="{ active: !archived }">
          <a class="nav-link" href="#" @click="archived = false">Published</a>
        </li>
        <li class="nav-item" :class="{ active: archived }">
          <a class="nav-link" href="#" @click="archived = true">Archived</a>
        </li>
      </ul>
      <!-- /#horizontal-nav -->

      <ul class="list-data has-button mt-0">
        <li class="data-heading d-none d-xl-block pt-4">
          <div class="row gx-2">
            <div class="col-sm-4">Integration Name</div>
            <div class="col-sm-4">Trigger</div>
            <div class="col-sm-4">Screens</div>
          </div>
        </li>
        <li v-for="item in filteredList" :key="item.id">
          <component
            :is="item.archived ? 'a' : 'router-link'"
            tag="a"
            class="data-row"
            :to="{
              name: 'settings.integrations.single',
              params: { integrationId: item.id },
            }"
          >
            <div class="row gx-2">
              <div class="col-sm-4">
                <p>
                  <span class="data-label d-xl-none">Integration Name</span>
                  {{ item.name }}
                </p>
              </div>
              <div class="col-sm-4">
                <p>
                  <span class="data-label d-xl-none">Trigger</span>
                  {{ getTriggerItem(item.trigger) }}
                </p>
              </div>
              <div class="col-sm-4">
                <p>
                  <span class="data-label d-xl-none">Screen</span>
                  {{ item.screens_count > 0 ? item.screens_count + ' Screens' : '-' }}
                </p>
              </div>
            </div>
          </component>
          <slot name="archive" :item="item"></slot>
        </li>
      </ul>
      <!-- /.list-data -->
    </div>
    <!-- /.card -->
  </div>
</template>
<script>

export default {
  props: {
    items: {
      required: true,
      type: Array,
    },
  },

  data () {
    return {
      archived: false,
      triggers: [
        { name: 'Initial Fault', value: 'initial_fault' },
        { name: 'Resolution', value: 'resolution' },
      ]
    }
  },

  computed: {
    filteredList () {
      return this.items.filter(({ archived }) => archived === this.archived)
    },
  },

  methods: {
    getTriggerItem (trigger) {
      return this.triggers.find((item) => item.value === trigger)?.name
    },
  },
}
</script>
